<template>
	<div id="Signatures" class="text-left menu-component">
		<div class="row">
			<div class="col-12">
				<p>Seus Produtos</p>
        		<template v-if="clientProducts.length > 0">
          			<div
            			class="card p-3 mb-4 product-card"
            			v-for="(item, index) in clientProducts"
            			:key="index"
          			>
            			<div class="row">
              				<div class="col-7 pr-0 product-name">
                				<p>{{ item.name }}</p>
              				</div>
              				<div class="col-5 text-right product-price">
                				<p>{{ item.priceValue | toCurrency }}</p>
              				</div>
						</div>
            			<div class="row">
              				<div class="col product-link pr-0">
                				<a :href="item.url" target="_blank" rel="noopener noreferrer">{{item.url}}</a>
              				</div>
							<!-- <div class="col-5 text-right product-next-invoice">
								Todo dia 15 do mês
							</div> -->
						</div>
          			</div>
        		</template>
        		<p v-else class="text-center">Buscando seus produtos...</p>
      		</div>
    	</div>
		<div class="row text-left">
			<div class="col-12">
				<hr class="mx--4">
				<div class="row m-0">
					<div class="col-12">
						<p v-b-toggle.historic-collapse class="historic-title">Histórico de pagamento <i class="fas fa-chevron-down float-right pt-1"></i></p>
						<b-collapse
						ref="historic-collapse"
						visible
						id="historic-collapse"
						class="mt-2"
						>
							<div class="row pb-4 align-items-center">
								<div class="col-6">
									<label>Faturas</label>
								</div>
								<div class="col-6">
									<select id="" class="form-control" v-model="filterBillsBy">
										<option value="all" selected>Todos</option>
										<option
										:value="item"
										v-for="item in clientProductsNames"
										:key="item.id"
										>
										{{ item }}
										</option>
									</select>
								</div>
							</div>
							<div
								class="card p-3 mb-4 historic-card"
								v-for="bill in clientHistoricCounter"
								:key="bill.id"
							>
								<div class="row">
									<div class="col-8 bill-id">
										<p>
										Nº da fatura: <strong>{{ bill.id }}</strong>
										</p>
									</div>
									<div class="col-4 text-right">
										<span
										class="pill"
										:class="[
											bill.status == 'paid' ? 'success' : '',
											bill.status == 'canceled' || bill.status == 'refused'
											? 'error'
											: ''
										]"
										>{{ bill.status | toPortuguese }}</span>
									</div>
									<div class="col-8 historic-name">
										<p>{{ bill.product }}</p>
									</div>
									<div class="col-4 text-right">
										<!--<p>Anual</p>-->
									</div>
									<div class="col-8">
										<p>Vencimento</p>
									</div>
									<div class="col-4 text-right pl-0">
										<p>{{ bill.expiry }}</p>
									</div>
									<div class="col-8">
										<p>Ref. Mês/Ano</p>
									</div>
									<div class="col-4 text-right">
										<p>{{ bill.referer }}</p>
									</div>
									<div class="col-12 text-right historic-value">
										<p>R$ {{ bill.value }}</p>
									</div>
									<div class="col-12 historic-link" v-if="bill.link">
										<a :href="bill.link">{{ messageLink(bill.status) }}</a>
									</div>
								</div>
							</div>
							<div
								class="row text-center"
								v-if="showHistoricCounter < totalHitoricFilterActive"
							>
								<div class="col-12">
								<span
									class="see-more-button"
									@click="showHistoricCounter += 2"
									>Ver mais</span
								>
								</div>
							</div>
						</b-collapse>
					</div>
				</div>
			</div>
		</div>
  	</div>
</template>

<script>
import axios from "axios";
export default {
	name: "Signatures",
  	data() {
		return {
			API_IN_PROGRESS: false,
			clientProducts: [],
			clientProductsNames: [],
			clientHistoric: [],
			totalHitoricFilterActive: 0,
			showHistoricCounter: 2,
			filterBillsBy: "all"
		};
  	},
  	filters: {
    	toCurrency(value) {
      		value = parseFloat(value);
			if (typeof value !== "number") {
        		return value;
      		}
      		var formatter = new Intl.NumberFormat("pt-BR", {
				style: "currency",
        		currency: "BRL",
        		minimumFractionDigits: 2
			});
      		return formatter.format(value);
    	},
    	toPortuguese(value) {
      		if (value == "paid") {
        		return "Pago";
      		} else if (value == "waiting payment") {
        		return "Pendente";
      		} else if (value == "canceled") {
        		return "Cancelado";
      		} else {
        		return "Recusado";
      		}
    	}
	},
  	methods: {
		async getProductsAndHistoric() {
			this.API_IN_PROGRESS = true;
			const getData = await this.getProducts();
			this.API_IN_PROGRESS = false;
		},
    	getProducts() {
      		return new Promise(resolve => {
				let token = this.$session.get("jwt");
				let siteId = this.$session.get("siteId");
				axios({
					method: "get",
					url: `${process.env.ROOT_API}/api/site/${siteId}/bill`,
					data: "",
					headers: {
						Authorization: "Bearer " + token
					}
				}).then(response => {
					this.clientProducts = response.data.contracts;          
					// Caso não haja assinatura ativa, redireciona pro checkout
					if(this.clientProducts.length == 0){
						var token = this.$store.state.siteActive.contract.token;
						this.$router.push("/checkout?token="+token);
					}
					this.clientProductsNames = [
						...new Set(this.clientProducts.map(prod => prod.name))
					];
					this.clientHistoric = response.data.bill;
					resolve(true);
				});
      		});
    	},
		messageLink(text) {
      		if (text == "paid") {
        		return "Nota fiscal";
      		} else {
        		return "Pagar agora";
      		}
		}
  	},
  	mounted() {
    	this.getProductsAndHistoric();
  	},
  	computed: {
		clientHistoricCounter() {
			if (this.filterBillsBy === "all") {
				this.totalHitoricFilterActive = this.clientHistoric.length;
				return this.clientHistoric.slice(0, this.showHistoricCounter);
			} else {
				this.totalHitoricFilterActive = this.clientHistoric.filter(
				bill => bill.product == this.filterBillsBy
				).length;
				return this.clientHistoric
				.filter(bill => bill.product == this.filterBillsBy)
				.slice(0, this.showHistoricCounter);
			}
		}
  	}
};
</script>

<style scoped>
.pill {
  background-color: #f2f2f2;
  color: #858585;
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 25px;
  min-width: 55px;
  display: inline-block;
  text-align: center;
}
.pill.success {
  background-color: #cff5d4;
}
.pill.error {
  background-color: #ff4a51;
  color: #fff;
}
.pill.alert {
}
.product-card,
.historic-card {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16);
}

.products-title,
.historic-title {
  font-family: "Montserrat", sans-serif;
  cursor: pointer;
}
.product-card .product-name {
  font-weight: 700;
  font-size: 16px;
}
.product-card .product-price {
  font-weight: 700;
  font-size: 14px;
}
.product-card .product-link,
.product-card .product-next-invoice {
  font-size: 11px;
}
.product-card .product-link a {
  color: var(--main-color);
}
.line-top {
  border-top: 1px solid rgba(112, 112, 112, 0.12);
}
.historic-card p {
  font-size: 14px;
  color: #777777;
  margin-bottom: 6px;
}
.historic-card .historic-name p {
  font-weight: 700;
}
.historic-card .historic-value p {
  font-weight: 400;
  color: #000;
}
.historic-card .historic-link a {
  color: var(--main-color);
  cursor: pointer;
}
.product-card .product-link a:hover,
.historic-card .historic-link a:hover {
  text-decoration: none;
}
.historic-card .bill-id p {
  font-size: 14px;
}
.see-more-button {
  color: var(--main-color);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/Signatures.vue